import React from 'react';
import { useSelector } from 'react-redux';
import { GeckoRow, GECKO_CONSTS } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import StatsLoader from '../../../components/StatsLoader';
import graphColours from 'constants/graphColours';

const ratingEmojis = {
  5: GECKO_CONSTS.RATINGS_TYPE_LOVE,
  4: GECKO_CONSTS.RATINGS_TYPE_HAPPY,
  3: GECKO_CONSTS.RATINGS_TYPE_NEUTRAL,
  2: GECKO_CONSTS.RATINGS_TYPE_SAD,
  1: GECKO_CONSTS.RATINGS_TYPE_ANGRY,
};

const ConversationRatings = ({ id, ratingsSelectHandler }) => {
  const conversationRatings = useSelector(
    (state) => state.statsRoute.conversationRatings
  );

  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingConversationRatingsStats
  );

  const totalRatings = conversationRatings.reduce(
    (total, { count }) => (total += Number(count)),
    0
  );
  const data = conversationRatings.reduce(
    (data, { count, rating_score }) => {
      return {
        ...data,
        [ratingEmojis[rating_score]]: Number(count),
      };
    },
    {
      [GECKO_CONSTS.RATINGS_TYPE_ANGRY]: 0,
      [GECKO_CONSTS.RATINGS_TYPE_SAD]: 0,
      [GECKO_CONSTS.RATINGS_TYPE_NEUTRAL]: 0,
      [GECKO_CONSTS.RATINGS_TYPE_HAPPY]: 0,
      [GECKO_CONSTS.RATINGS_TYPE_LOVE]: 0,
    }
  );

  const header = ['rating', 'Conversations'];
  const graphData = [header, ...Object.entries(data)];

  const graphOptions = {
    hAxis: {
      title: '',
      minValue: 0,
      labelWrap: false,
    },
    vAxis: {
      title: 'Total Ratings',
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: { count: -1 },
    },
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary],
  };

  const chartEvents = [
    {
      eventName: 'select',
      callback: ({ chartWrapper }) => {
        const [data] = chartWrapper.getChart().getSelection();
        if (!data || isNaN(data.row)) return;
        ratingsSelectHandler(data.row + 1);
      },
    },
  ];

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={totalRatings}
              suffix={
                <span style={{ fontSize: '14px' }}>{'Total Ratings'}</span>
              }
              showSecondary={false}
            />
          </div>
        </GeckoRow>

        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={graphOptions}
              graph_id={id}
              width="100%"
              height="400px"
              chartEvents={chartEvents}
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default ConversationRatings;
